import * as React from 'react';

function SvgBasket2Fill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M5.929 1.757a.5.5 0 10-.858-.514L2.217 6H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h.623l1.844 6.456A.75.75 0 003.69 15h8.622a.75.75 0 00.722-.544L14.877 8h.623a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1.717L10.93 1.243a.5.5 0 10-.858.514L12.617 6H3.383L5.93 1.757zM4 10a1 1 0 012 0v2a1 1 0 11-2 0v-2zm3 0a1 1 0 012 0v2a1 1 0 11-2 0v-2zm4-1a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1z' />
		</svg>
	);
}

export default SvgBasket2Fill;
